exports.config = {
    apiUrl: "https://dev-api.empireholdings.com/api",
    apiKey: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkaXZpc2lvbiI6MiwibmFtZSI6IlBhbG0gQmVhY2ggU3BvcnRzIENsdWIiLCJpYXQiOjE2MTQ2MjU3NDd9.x3ASrXn7PdQMJzc-GCIB6UriiYSfJYf8bKFe-NvY5GQ",
    pixelScriptA : "mvmpjlu",
    pixelScriptB : "yiwm8br"
}
